import { render, staticRenderFns } from "./link-table-column-address-item.vue?vue&type=template&id=6d501c0b&"
import script from "./link-table-column-address-item.vue?vue&type=script&lang=js&"
export * from "./link-table-column-address-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports